import { render, staticRenderFns } from "./CardValueSubtitleComponent.vue?vue&type=template&id=69b7f181&"
import script from "./CardValueSubtitleComponent.vue?vue&type=script&lang=js&"
export * from "./CardValueSubtitleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports